var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Instagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    d: "M16,46h18c6.627,0,12-5.373,12-12V16c0-6.627-5.373-12-12-12H16C9.373,4,4,9.373,4,16v18C4,40.627,9.373,46,16,46z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    cx: 25,
    cy: 25,
    r: 10
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 37,
    cy: 13,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Instagram);
export default __webpack_public_path__ + "static/media/icons8-instagram.1df07686031bb6d7c310e73da0f3a024.svg";
export { ForwardRef as ReactComponent };